/* globals urls, themeObj, symposium, validate, RSVP */

var $ = jQuery.noConflict();

window.ScientificProgram = function(){
	this.RSVP = RSVP;
	this.formSelector = '#symp-sci-program-form';
	this.formMessagingSelector = this.formSelector + ' .message-target';
	this.onRegPage = $(this.formSelector).length > 0;
	this.isEditMode = function(){
		return !!$('.symposium-registration-form input[name="EnrollmentToUpdate"]').val();
	};
	this.programConstrains = {
		ReservedSeat:{
			presence: true
		},
		AttendingSymposium:{
			presence: true
		},
		ShirtSize:{
			presence: true
		}
	};
	this.materialsConstrains = {
		AttendingSymposium:{
			presence: true
		}
	};
};

// Return the constraint object which applies to the current state (i.e. are they editing an enrollment, or are they attending the program)
ScientificProgram.prototype.getConstraints = function(){
	// Editing a previous enrollment has no validation constraints
	if( this.isEditMode() ){
		return {};
	}
	
	return parseInt($('input[name="AttendingSymposium"]:checked').val()) === 1 ? this.programConstrains : this.materialsConstrains;
};

// Update attending program status in the user's session and return the new total or an error message
ScientificProgram.prototype.updateAttending = function(attending){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_attendance',
				attending: attending
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Update attending Welcome Reception status in the user's session and return the new total or an error message
ScientificProgram.prototype.updateAttendingWelcome = function(attending){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_welcome_attending',
				attending: attending
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Update attending Friday Night status in the user's session and return the new total or an error message
ScientificProgram.prototype.updateAttendingFriday = function(attending){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_friday_attending',
				attending: attending
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Update attending First Time Dinner status in the user's session and return the new total or an error message
ScientificProgram.prototype.updateAttendingFirstTimeDinner = function(attending){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_first_time_dinner_attending',
				attending: attending
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Update purchasing virtual course status in the user's session and return the new total or an error message
ScientificProgram.prototype.updatePurchasedVirtualCourse = function(purchasing){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_virtual_course_purchasing',
				purchasing: purchasing
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Update tallies of additional welcome reception and friday night attendees in the user's session and return the new total or an error message
ScientificProgram.prototype.updateAdditionalTallies = function(welcomeAdults, welcomeYouth, fridayAdults, fridayYouth, firstTimeDinnerGuests){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_additional_tallies',
				welcomeAdults: welcomeAdults,
				welcomeYouth: welcomeYouth,
				fridayAdults: fridayAdults,
				fridayYouth: fridayYouth,
				firstTimeDinnerGuests: firstTimeDinnerGuests
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.total );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

// Add this Scientific Program registration to the user's cart and redirect them to the appropriate page or display an error message
ScientificProgram.prototype.addToCart = function(currentCartItem, shirtSize, dietaryRestrictions){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'add_sci_program_to_cart',
				shirtSize: shirtSize,
				dietaryRestrictions: dietaryRestrictions,
				currentCartItem: currentCartItem || ''
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( res.data.redirect );
			}
			reject( res.message || 'An error occurred while adding your registration to the cart' );
		});
	});
};

// Update reserved seat in the user's session and return the an object representing the new seat's data or an error message
ScientificProgram.prototype.updateSeatFields = function(seatData){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'update_sci_program_seat_data',
				seatId: seatData.seatId,
				seatNumber: seatData.seatNumber,
				seatExpiration: seatData.seatExpiration
			}
		})
		.done(function( res ) {
			if( res && res.success ){
				resolve( {
					seatId: res.data.seatId,
					seatNumber: res.data.seatNumber,
					seatExpiration: res.data.seatExpiration,
					seatExpirationFormatted: res.data.seatExpirationFormatted,
					newCartItemKey: seatData.cartItemKey
				} );
			}
			reject( res.message || 'An error occurred while updating your registration' );
		});
	});
};

(function($, SymposiumRegistration, ScientificProgram) {
	
	if( ScientificProgram.onRegPage ){
		// Once the page has loaded, refresh the page if the user got here using the back/forward browser button
		SymposiumRegistration.refreshOnBackNavigation();
		
		$('body').on( 'kois.seatReserved', function(e, seatData){
			SymposiumRegistration.updateLoadingState(true);
			ScientificProgram.updateSeatFields( seatData ).then(function(registrationSeatData){
				// If the cart item was replaced as part of the seat update, refresh the page with the cart item key in the URL query string
				if( registrationSeatData.newCartItemKey ){
					window.location.href = window.location.pathname + '?cart_item=' + registrationSeatData.newCartItemKey;
				}
				// Otherwise update the appropriate fields and allow the user to continue editing
				else{
					// Update form fields
					$( ScientificProgram.formSelector + ' input[name="ReservedSeat"]' ).val( registrationSeatData.seatId );
					$( ScientificProgram.formSelector + ' input[name="ReservedSeatNumber"]' ).val( registrationSeatData.seatNumber );
					$( ScientificProgram.formSelector + ' input[name="ReservedSeatExpiration"]' ).val( registrationSeatData.seatExpiration );
					// Update displayed seat info
					$( ScientificProgram.formSelector + ' .selected-seat-number-display' ).html( registrationSeatData.seatNumber );
					$( ScientificProgram.formSelector + ' .selected-seat-expiration-display' ).html( registrationSeatData.seatExpirationFormatted );
					// Remove loading state and display seating info
					$('#selected-seat-info').removeClass( 'hidden' );
					SymposiumRegistration.updateLoadingState(false);
				}
			}).catch(function(error){
				SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
			});
		} );
	}
	
	$('input[name="AttendingSymposium"]').change(function(e){
		SymposiumRegistration.updateLoadingState(true);
		var hideCheckoutMarkup = $(this).data( 'hidecheckout' );
		var attending = parseInt( $(this).val() ) === 1;
		ScientificProgram.updateAttending(attending).then(function(total){
			SymposiumRegistration.updateTotal( total );
			if( attending ){
				$('#attending-symp-sci-program').removeClass('hidden');
				$('#not-attending-symp-sci-program').addClass('hidden');
			}
			else{
				$('#attending-symp-sci-program').addClass('hidden');
				$('#not-attending-symp-sci-program').removeClass('hidden');
			}
			
			// Hide or show the total and checkout button. Used to hide irrelevant markup when a user can only waitlist for the Sci Program
			if( hideCheckoutMarkup ){
				$( '#symp-sci-reg-checkout-contain' ).addClass('hidden');
			}
			else{
				$( '#symp-sci-reg-checkout-contain' ).removeClass('hidden');
			}
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});
	
	$('input[name="AttendingWelcomeReception"]').change(function(e){
		SymposiumRegistration.updateLoadingState(true);
		var attending = $(this).prop('checked');
		ScientificProgram.updateAttendingWelcome(attending).then(function(total){
			SymposiumRegistration.updateTotal( total );
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});
	
	$('input[name="AttendingFridayNight"]').change(function(e){
		SymposiumRegistration.updateLoadingState(true);
		var attending = $(this).prop('checked');
		ScientificProgram.updateAttendingFriday(attending).then(function(total){
			SymposiumRegistration.updateTotal( total );
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});

	$('input[name="PurchasedFirstTimeDinner"]').change(function(e){
		SymposiumRegistration.updateLoadingState(true);
		var attending = $(this).prop('checked');
		ScientificProgram.updateAttendingFirstTimeDinner(attending).then(function(total){
			SymposiumRegistration.updateTotal( total );
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});

	$('input[name="PurchasedVirtualCourse"]').change(function(e){
		SymposiumRegistration.updateLoadingState(true);
		var purchasing = $(this).prop('checked');
		ScientificProgram.updatePurchasedVirtualCourse(purchasing).then(function(total){
			SymposiumRegistration.updateTotal( total );
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});
	
	// Toggle Welcome Reception guest fields
	$('input[name="GuestsAttendingWelcomeReception"]').change(function(e){
		if( $(this).prop('checked') ){
			$('.welcome-reception-guest-field').removeClass('hidden');
		}
		else{
			$('.welcome-reception-guest-field').addClass('hidden');
		}
	});
	
	// Toggle Friday Night Event guest fields
	$('input[name="GuestsAttendingFridayNight"]').change(function(e){
		if( $(this).prop('checked') ){
			$('.friday-night-guest-field').removeClass('hidden');
		}
		else{
			$('#friday-night-over-21').val(0);
			$('#friday-night-under-21').val(0);
			$('.friday-night-guest-field').addClass('hidden');
		}
	});
	
	// Toggle First Time Dinner guest fields
	$('input[name="GuestsAttendingFirstTimeDinnerCheckbox"').change(function(e){
		
		if( $(this).prop('checked') ){
			$('.guests-attending-first-time-dinner-field').removeClass('hidden');
		}
		else{
			$('#guests-attending-first-time-dinner').val(0);
			$('.guests-attending-first-time-dinner-field').addClass('hidden');
		}
	});
	
	var additionalAttendeeFieldSelectors = [
		'input[name="WelcomeReceptionOver21Additional"]',
		'input[name="WelcomeReceptionUnder21Additional"]',
		'input[name="FridayNightOver21Additional"]',
		'input[name="FridayNightUnder21Additional"]',
		'input[name="GuestsAttendingFirstTimeDinner"]',
		'input[name="GuestsAttendingFirstTimeDinnerCheckbox"]',
		'input[name="GuestsAttendingFridayNight"]'
	];
	// Listen for a "change" or "changed.spinner" event on these inputs, update the additional attendee tallies
	$(additionalAttendeeFieldSelectors.join(',')).on('change changed.spinner', function(e){
		SymposiumRegistration.updateLoadingState(true);
		var welcomeAdults = $(additionalAttendeeFieldSelectors[0]).val();
		var welcomeYouth = $(additionalAttendeeFieldSelectors[1]).val();
		var fridayAdults = $(additionalAttendeeFieldSelectors[2]).val();
		var fridayYouth = $(additionalAttendeeFieldSelectors[3]).val();
		var firstTimeDinnerGuests = $(additionalAttendeeFieldSelectors[4]).val();
		
		ScientificProgram.updateAdditionalTallies(welcomeAdults, welcomeYouth, fridayAdults, fridayYouth, firstTimeDinnerGuests).then(function(total){
			SymposiumRegistration.updateTotal( total );
			SymposiumRegistration.updateLoadingState(false);
		}).catch(function(error){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
		});
	});
	
	$(ScientificProgram.formSelector).submit(function(e){
		e.preventDefault();
		SymposiumRegistration.clearRegistrationErrors( ScientificProgram.formMessagingSelector );
		SymposiumRegistration.updateLoadingState(true);
		var objRegistrationData = validate.collectFormValues(e.target);
		var objConstraints = ScientificProgram.getConstraints();
		var objValidationErrors = SymposiumRegistration.validate(objRegistrationData, objConstraints);
		if( objValidationErrors ){
			SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, objValidationErrors );
		}
		else{
			ScientificProgram.addToCart( objRegistrationData.CurrentCartItem, objRegistrationData.ShirtSize, objRegistrationData.FoodAllergies ).then(function(redirect){
				// Redirect the user to the appropriate location
				window.location = redirect;
			}).catch(function(error){
				// Display add to cart error message
				SymposiumRegistration.showRegistrationErrors( ScientificProgram.formMessagingSelector, {}, 'Registration Error', error );
			});
		}
	});
})(jQuery, new SymposiumRegistration(), new ScientificProgram());